/* eslint-disable import/first */
/* global globalThis */
// Generated from wasel-app/lib/backend/client.ts. Run backend/build-client.mjs to update.
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// ../lib/backend/client.ts
import {
  createClient
} from "@supabase/supabase-js";

// ../lib/backend/transport.ts
var READ_TIMEOUT_MS = 25e3;
var WRITE_TIMEOUT_MS = 9e4;
var UPLOAD_TIMEOUT_MS = 6e4;
var MAX_RESPONSE_BYTES = 16 * 1024 * 1024;
function requestError(code, message) {
  return Object.assign(new Error(message), { code });
}
async function withRequestDeadline(operation, { timeoutMs, signal }) {
  if (!Number.isFinite(timeoutMs) || timeoutMs <= 0) {
    throw new RangeError("A positive request timeout is required.");
  }
  const controller = new AbortController();
  let timer;
  let cancel = () => void 0;
  const interrupted = new Promise((_resolve, reject) => {
    const stop = (error) => {
      reject(error);
      controller.abort(error);
    };
    cancel = () => stop(requestError("cancelled", "The request was cancelled."));
    if (signal?.aborted) {
      cancel();
      return;
    }
    signal?.addEventListener("abort", cancel, { once: true });
    timer = setTimeout(
      () => stop(requestError("deadline-exceeded", "The request timed out.")),
      timeoutMs
    );
  });
  try {
    const work = Promise.resolve().then(() => {
      if (controller.signal.aborted) throw controller.signal.reason;
      return operation(controller.signal);
    });
    return await Promise.race([work, interrupted]);
  } finally {
    if (timer !== void 0) clearTimeout(timer);
    signal?.removeEventListener("abort", cancel);
  }
}
async function readResponseBytes(response, signal, maxBytes = MAX_RESPONSE_BYTES) {
  if (signal.aborted) throw signal.reason;
  if (!response.body?.getReader) {
    const bytes = new Uint8Array(await response.arrayBuffer());
    if (bytes.byteLength > maxBytes) {
      throw requestError("resource-exhausted", "The response exceeds the supported size.");
    }
    return bytes;
  }
  const reader = response.body.getReader();
  const cancel = () => {
    void reader.cancel(signal.reason).catch(() => void 0);
  };
  signal.addEventListener("abort", cancel, { once: true });
  const chunks = [];
  let size = 0;
  try {
    while (true) {
      if (signal.aborted) throw signal.reason;
      const { done, value } = await reader.read();
      if (signal.aborted) throw signal.reason;
      if (done) break;
      size += value.byteLength;
      if (size > maxBytes) {
        void reader.cancel().catch(() => void 0);
        throw requestError("resource-exhausted", "The response exceeds the supported size.");
      }
      chunks.push(value);
    }
    const bytes = new Uint8Array(size);
    let offset = 0;
    for (const chunk of chunks) {
      bytes.set(chunk, offset);
      offset += chunk.byteLength;
    }
    return bytes;
  } finally {
    signal.removeEventListener("abort", cancel);
    reader.releaseLock();
  }
}
async function readJsonResponse(response, signal) {
  const bytes = await readResponseBytes(response, signal);
  try {
    return JSON.parse(new TextDecoder().decode(bytes));
  } catch {
    throw requestError("unavailable", "The server returned an incomplete or invalid response.");
  }
}
var boundedFetch = async (input, init) => withRequestDeadline(
  async (signal) => {
    const response = await globalThis.fetch(input, { ...init, signal });
    const bytes = await readResponseBytes(response, signal);
    return new Response([101, 204, 205, 304].includes(response.status) ? null : bytes, {
      status: response.status,
      statusText: response.statusText,
      headers: response.headers
    });
  },
  { timeoutMs: READ_TIMEOUT_MS, signal: init?.signal ?? void 0 }
);

// ../lib/backend/client.ts
var SUPABASE_URL = "https://uqttxidcyojdnigqperh.supabase.co";
var SUPABASE_FUNCTION_REGION = "ap-northeast-1";
var SUPABASE_PUBLISHABLE_KEY = "sb_publishable_HkPYShzipWsN6f_asLq6Hg_kmML4bPc";
var client;
var ready;
var session = null;
var authListeners = /* @__PURE__ */ new Set();
var memory = /* @__PURE__ */ new Map();
function memoryStorage() {
  return {
    getItem: (key) => memory.get(key) ?? null,
    setItem: (key, value) => {
      memory.set(key, value);
    },
    removeItem: (key) => {
      memory.delete(key);
    }
  };
}
function createBrowserStorage(kind) {
  const fallback = memoryStorage();
  const browser = () => {
    if (typeof window === "undefined") return null;
    return kind === "session" ? window.sessionStorage : window.localStorage;
  };
  return {
    getItem(key) {
      try {
        const target = browser();
        return target ? target.getItem(key) : fallback.getItem(key);
      } catch {
        return fallback.getItem(key);
      }
    },
    setItem(key, value) {
      fallback.setItem(key, value);
      try {
        browser()?.setItem(key, value);
      } catch {
      }
    },
    removeItem(key) {
      fallback.removeItem(key);
      try {
        browser()?.removeItem(key);
      } catch {
      }
    }
  };
}
function initializeBackend(options = {}) {
  if (client) return client;
  client = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    global: { fetch: boundedFetch },
    auth: {
      storage: options.storage ?? memoryStorage(),
      persistSession: true,
      autoRefreshToken: options.autoRefreshToken ?? true,
      detectSessionInUrl: false,
      storageKey: "wasel.supabase.auth"
    }
  });
  let acceptedUserSignature;
  const accept = (value) => {
    const previousIdentity = session?.user.id;
    session = value;
    if (value) void client.realtime.setAuth(value.access_token).catch(() => {
    });
    const signature = JSON.stringify(value?.user ?? null);
    if (signature === acceptedUserSignature) return;
    acceptedUserSignature = signature;
    auth.currentUser = value ? new User(value.user) : null;
    for (const callback of authListeners) callback(auth.currentUser);
    if (value && previousIdentity !== value.user.id) setTimeout(refreshBackendSubscriptions, 0);
  };
  client.auth.onAuthStateChange((_event, value) => {
    accept(value);
  });
  ready = withRequestDeadline(() => client.auth.getSession(), { timeoutMs: READ_TIMEOUT_MS }).then(
    ({ data, error }) => {
      if (error) throw error;
      accept(data.session);
    }
  );
  if (typeof window !== "undefined" && typeof window.addEventListener === "function") {
    window.addEventListener("online", refreshBackendSubscriptions);
    if (typeof document !== "undefined") {
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") refreshBackendSubscriptions();
      });
    }
  }
  return client;
}
function backendClient() {
  if (!client) throw new Error("Supabase is not initialized.");
  return client;
}
var authFailure = (error) => Object.assign(new Error(error.message ?? "Authentication failed."), {
  code: {
    invalid_credentials: "auth/invalid-credential",
    user_banned: "auth/user-disabled",
    over_request_rate_limit: "auth/too-many-requests",
    over_email_send_rate_limit: "auth/too-many-requests",
    weak_password: "auth/weak-password"
  }[error.code] ?? (error.status === 429 ? "auth/too-many-requests" : "auth/internal-error")
});
var User = class _User {
  constructor(record) {
    this.record = record;
    __publicField(this, "uid");
    __publicField(this, "email");
    __publicField(this, "displayName");
    __publicField(this, "emailVerified");
    __publicField(this, "photoURL");
    __publicField(this, "phoneNumber");
    this.uid = record.app_metadata?.firebase_uid ?? record.id;
    this.email = record.email ?? null;
    this.displayName = record.user_metadata?.name ?? null;
    this.emailVerified = record.app_metadata?.firebase_email_verified ?? Boolean(record.email_confirmed_at);
    this.photoURL = record.user_metadata?.avatar_url ?? null;
    this.phoneNumber = record.phone ? `+${record.phone.replace(/^\+/, "")}` : null;
  }
  async getIdToken(forceRefresh = false) {
    await ready;
    if (forceRefresh) {
      const { data, error } = await backendClient().auth.refreshSession();
      if (error) throw authFailure(error);
      session = data.session;
    }
    if (!session || session.user.id !== this.record.id)
      throw Object.assign(new Error("Please sign in."), { code: "auth/user-token-expired" });
    return session.access_token;
  }
  async getIdTokenResult(forceRefresh = false) {
    const token = await this.getIdToken(forceRefresh);
    const { data, error } = await backendClient().auth.getUser(token);
    if (error) throw authFailure(error);
    return {
      token,
      claims: {
        ...data.user.app_metadata?.firebase_custom_claims,
        admin: data.user.app_metadata?.admin === true,
        email: data.user.email
      }
    };
  }
  async reload() {
    const { data, error } = await backendClient().auth.getUser();
    if (error) throw authFailure(error);
    Object.assign(this, new _User(data.user));
  }
};
var auth = { currentUser: null, authStateReady: () => ready };
var db = { kind: "documents" };
var functions = { kind: "functions" };
var rtdb = { kind: "realtime" };
var storage = { kind: "storage" };
function onAuthStateChanged(_auth, callback, error) {
  let active = true;
  let notified = false;
  let lastUid = null;
  const listener = (user) => {
    if (active && (!notified || lastUid !== (user?.uid ?? null))) {
      notified = true;
      lastUid = user?.uid ?? null;
      callback(user);
    }
  };
  authListeners.add(listener);
  void ready.then(() => listener(auth.currentUser)).catch(error ?? (() => {
  }));
  return () => {
    active = false;
    authListeners.delete(listener);
  };
}
async function signInWithEmailAndPassword(_auth, email, password) {
  const { data, error } = await backendClient().auth.signInWithPassword({ email, password });
  if (error) throw authFailure(error);
  session = data.session;
  const user = new User(data.user);
  auth.currentUser = user;
  return { user, providerId: "password", operationType: "signIn" };
}
async function signOut(_auth) {
  const { error } = await backendClient().auth.signOut({ scope: "local" });
  if (error) throw authFailure(error);
  session = null;
  auth.currentUser = null;
}
async function updateProfile(user, values) {
  const { data, error } = await backendClient().auth.updateUser({
    data: {
      ...values.displayName !== void 0 ? { name: values.displayName } : {},
      ...values.photoURL !== void 0 ? { avatar_url: values.photoURL } : {}
    }
  });
  if (error) throw authFailure(error);
  Object.assign(user, new User(data.user));
}
var EmailAuthProvider = {
  credential: (email, password) => ({ email, password })
};
async function reauthenticateWithCredential(user, credential) {
  if (user.email?.toLowerCase() !== credential.email.toLowerCase())
    throw Object.assign(new Error("Account mismatch."), { code: "auth/user-mismatch" });
  return signInWithEmailAndPassword(auth, credential.email, credential.password);
}
var pendingReads = /* @__PURE__ */ new Map();
var throttledUntil = /* @__PURE__ */ new Map();
var activeSubscriptions = /* @__PURE__ */ new Set();
function refreshBackendSubscriptions() {
  for (const refresh of activeSubscriptions) refresh();
}
function throttleKey(identity, action, input) {
  return `${identity}:${action}:${input.name ?? input.action ?? ""}`;
}
var activeReads = 0;
var waitingReads = [];
async function withReadSlot(operation, signal) {
  if (signal.aborted) throw signal.reason;
  if (activeReads >= 6) {
    await new Promise((resolve, reject) => {
      const start = () => {
        signal.removeEventListener("abort", cancel);
        resolve();
      };
      const cancel = () => {
        const index = waitingReads.indexOf(start);
        if (index >= 0) waitingReads.splice(index, 1);
        reject(signal.reason);
      };
      waitingReads.push(start);
      signal.addEventListener("abort", cancel, { once: true });
    });
  } else activeReads++;
  let cancelActive;
  try {
    if (signal.aborted) throw signal.reason;
    return await new Promise((resolve, reject) => {
      cancelActive = () => reject(signal.reason);
      signal.addEventListener("abort", cancelActive, { once: true });
      Promise.resolve().then(operation).then(resolve, reject);
    });
  } finally {
    if (cancelActive) signal.removeEventListener("abort", cancelActive);
    const next = waitingReads.shift();
    if (next) next();
    else activeReads--;
  }
}
async function request(action, input, options = {}) {
  await withRequestDeadline(() => ready, { timeoutMs: READ_TIMEOUT_MS, signal: options.signal });
  const identity = session?.user.id ?? "anonymous";
  const isRead = action === "documents" ? ["get", "query", "directory"].includes(input.action) : action === "realtime" ? ["get", "unread", "metadata", "history"].includes(input.action) : action === "files" ? ["url", "metadata"].includes(input.action) : ["admin-reports", "wallet-history"].includes(action);
  const key = identity + ":" + action + ":" + JSON.stringify(input);
  const execute = () => withRequestDeadline(
    (signal) => isRead ? withReadSlot(() => executeRequest(action, input, identity, signal), signal) : executeRequest(action, input, identity, signal),
    {
      timeoutMs: options.timeout ?? (isRead ? READ_TIMEOUT_MS : WRITE_TIMEOUT_MS),
      signal: options.signal
    }
  );
  if (!isRead || options.signal) return execute();
  const pending = pendingReads.get(key);
  if (pending) return pending;
  const operation = execute().finally(() => pendingReads.delete(key));
  pendingReads.set(key, operation);
  return operation;
}
async function executeRequest(action, input, identity, signal) {
  await ready;
  const { data, error } = await backendClient().auth.getSession();
  if (error) throw authFailure(error);
  if ((session?.user.id ?? "anonymous") !== identity || (data.session?.user.id ?? "anonymous") !== identity)
    throw Object.assign(new Error("Account changed."), { code: "unauthenticated" });
  session = data.session;
  const operationKey = throttleKey(identity, action, input);
  const remaining = Math.max(throttledUntil.get(identity) ?? 0, throttledUntil.get(operationKey) ?? 0) - Date.now();
  if (remaining > 0)
    throw Object.assign(new Error("Too many requests. Please retry shortly."), {
      code: "resource-exhausted",
      details: { retryAfterSeconds: Math.ceil(remaining / 1e3) }
    });
  if (signal.aborted) throw signal.reason;
  const response = await fetch(
    `${SUPABASE_URL}/functions/v1/wasel-api/${action}?forceFunctionRegion=${SUPABASE_FUNCTION_REGION}`,
    {
      method: "POST",
      signal,
      headers: {
        "Content-Type": "application/json",
        apikey: SUPABASE_PUBLISHABLE_KEY,
        "x-region": SUPABASE_FUNCTION_REGION,
        ...session ? { Authorization: `Bearer ${session.access_token}` } : {}
      },
      body: JSON.stringify(input)
    }
  );
  const result = await readJsonResponse(response, signal);
  if (!result || typeof result !== "object")
    throw requestError("unavailable", "The server returned an invalid response.");
  if (response.status === 429)
    throttledUntil.set(
      result.error?.details?.scope === "gateway" ? identity : operationKey,
      Date.now() + Math.max(1, Math.min(300, Number(result.error?.details?.retryAfterSeconds) || 30)) * 1e3
    );
  if (!response.ok || result.error)
    throw Object.assign(new Error(result.error?.message ?? "Service is unavailable."), {
      code: result.error?.code ?? "unavailable",
      details: result.error?.details
    });
  if (!Object.prototype.hasOwnProperty.call(result, "data"))
    throw requestError("unavailable", "The server did not confirm the operation result.");
  return result.data;
}
function httpsCallable(_functions, name, options) {
  return async (data) => {
    try {
      return { data: await request("call", { name, data }, options) };
    } catch (error) {
      if (!error.code?.startsWith("functions/"))
        error.code = `functions/${error.code ?? "internal"}`;
      throw error;
    }
  };
}
var Timestamp = class _Timestamp {
  constructor(seconds, nanoseconds) {
    this.seconds = seconds;
    this.nanoseconds = nanoseconds;
  }
  static now() {
    return _Timestamp.fromMillis(Date.now());
  }
  static fromDate(date) {
    return _Timestamp.fromMillis(date.getTime());
  }
  static fromMillis(value) {
    return new _Timestamp(Math.floor(value / 1e3), Math.round(value % 1e3 * 1e6));
  }
  toMillis() {
    return this.seconds * 1e3 + this.nanoseconds / 1e6;
  }
  toDate() {
    return new Date(this.toMillis());
  }
  toJSON() {
    return this.toDate().toISOString();
  }
  isEqual(other) {
    return this.seconds === other.seconds && this.nanoseconds === other.nanoseconds;
  }
};
function hydrate(value, key = "") {
  if (typeof value === "string" && /(?:At|Time|Until|date|timestamp)$/.test(key) && /^\d{4}-\d\d-\d\dT.*Z$/.test(value))
    return Timestamp.fromMillis(Date.parse(value));
  if (Array.isArray(value)) return value.map((v) => hydrate(v));
  if (value && typeof value === "object")
    return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, hydrate(v, k)]));
  return value;
}
var serverTimestamp = () => ({ __waselField: "timestamp" });
var deleteField = () => ({ __waselField: "delete" });
var increment = (operand) => ({ __waselField: "increment", operand });
var DocumentReference = class {
  constructor(path) {
    this.path = path;
    __publicField(this, "kind", "document");
  }
  get id() {
    return this.path.split("/").at(-1);
  }
  get parent() {
    return new CollectionReference(this.path.split("/").slice(0, -1).join("/"));
  }
};
var CollectionReference = class {
  constructor(path) {
    this.path = path;
    __publicField(this, "kind", "collection");
    __publicField(this, "group", false);
    __publicField(this, "filters", []);
    __publicField(this, "orders", []);
    __publicField(this, "maximum");
    __publicField(this, "cursor");
  }
  get id() {
    return this.path.split("/").at(-1);
  }
  get parent() {
    const parts = this.path.split("/");
    return parts.length > 1 ? new DocumentReference(parts.slice(0, -1).join("/")) : null;
  }
};
var pathOf = (base, parts) => [base?.path, ...parts].filter(Boolean).join("/");
function newId() {
  const bytes = new Uint8Array(16);
  if (!globalThis.crypto?.getRandomValues)
    throw new Error("Secure random number generation is unavailable.");
  globalThis.crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}
function doc(base, ...parts) {
  return new DocumentReference(pathOf(base, parts.length ? parts : [newId()]));
}
function collection(base, ...parts) {
  return new CollectionReference(pathOf(base, parts));
}
function collectionGroup(_db, path) {
  const ref2 = new CollectionReference(path);
  ref2.group = true;
  return ref2;
}
var where = (field, operator, value) => ({
  constraint: "where",
  field,
  operator,
  value
});
var orderBy = (field, direction = "asc") => ({
  constraint: "orderBy",
  field,
  direction
});
var limit = (maximum) => ({ constraint: "limit", maximum });
var startAfter = (...cursor) => ({ constraint: "cursor", cursor });
function query(reference, ...constraints) {
  const copy = Object.assign(Object.create(Object.getPrototypeOf(reference)), reference);
  if (copy.filters) copy.filters = [...copy.filters];
  if (copy.orders) copy.orders = [...copy.orders];
  for (const c of constraints) {
    if (c.constraint === "where") copy.filters.push([c.field, c.operator, c.value]);
    else if (c.constraint === "orderBy") copy.orders.push([c.field, c.direction]);
    else if (c.constraint === "limit") copy.maximum = c.maximum;
    else if (c.constraint === "cursor") copy.cursor = c.cursor;
    else Object.assign(copy, c);
  }
  return copy;
}
var DocumentSnapshot = class {
  constructor(record) {
    this.record = record;
    __publicField(this, "ref");
    __publicField(this, "id");
    this.ref = new DocumentReference(record.path);
    this.id = this.ref.id;
  }
  exists() {
    return this.record.exists;
  }
  data() {
    return this.exists() ? hydrate(this.record.data) : void 0;
  }
  get(key) {
    return key.split(".").reduce((v, k) => v?.[k], this.data());
  }
};
var QueryDocumentSnapshot = class extends DocumentSnapshot {
  data() {
    return hydrate(this.record.data);
  }
};
var QuerySnapshot = class {
  constructor(records) {
    __publicField(this, "docs");
    __publicField(this, "size");
    __publicField(this, "empty");
    __publicField(this, "previous");
    this.docs = records.map((r) => new QueryDocumentSnapshot(r));
    this.size = records.length;
    this.empty = !records.length;
  }
  forEach(callback) {
    this.docs.forEach(callback);
  }
  docChanges() {
    const before = new Map((this.previous?.docs ?? []).map((d) => [d.ref.path, d]));
    const current = new Map(this.docs.map((d) => [d.ref.path, d]));
    return [
      ...this.docs.filter(
        (d) => !before.has(d.ref.path) || before.get(d.ref.path).record.version !== d.record.version || JSON.stringify(before.get(d.ref.path).record.data) !== JSON.stringify(d.record.data)
      ).map((d) => ({ type: before.has(d.ref.path) ? "modified" : "added", doc: d })),
      ...(this.previous?.docs ?? []).filter((d) => !current.has(d.ref.path)).map((d) => ({ type: "removed", doc: d }))
    ];
  }
};
async function getDoc(ref2) {
  return new DocumentSnapshot(await request("documents", { action: "get", path: ref2.path }));
}
async function getDocs(ref2) {
  const data = await request("documents", { action: "query", ...ref2 });
  return new QuerySnapshot(data.docs);
}
var commit = (writes, reads = []) => request("documents", { action: "commit", writes, reads });
function setDoc(ref2, data, options) {
  return commit([{ kind: "set", path: ref2.path, data, merge: Boolean(options?.merge) }]);
}
function updateDoc(ref2, data) {
  return commit([{ kind: "update", path: ref2.path, data }]);
}
function deleteDoc(ref2) {
  return commit([{ kind: "delete", path: ref2.path }]);
}
async function addDoc(ref2, data) {
  const target = doc(ref2);
  await setDoc(target, data);
  return target;
}
function writeBatch(_db) {
  const writes = [];
  const batch = {
    set: (ref2, data, options) => {
      writes.push({ kind: "set", path: ref2.path, data, merge: Boolean(options?.merge) });
      return batch;
    },
    update: (ref2, data) => {
      writes.push({ kind: "update", path: ref2.path, data });
      return batch;
    },
    delete: (ref2) => {
      writes.push({ kind: "delete", path: ref2.path });
      return batch;
    },
    commit: () => commit(writes)
  };
  return batch;
}
async function runTransaction(_db, callback) {
  for (let attempt = 0; ; attempt++) {
    const writes = [], reads = [];
    const transaction = {
      get: async (ref2) => {
        if (writes.length) throw new Error("Read before writing in a transaction.");
        const snapshot = await getDoc(ref2);
        reads.push({ path: ref2.path, version: snapshot.record.version });
        return snapshot;
      },
      set: (ref2, data, options) => {
        writes.push({ kind: "set", path: ref2.path, data, merge: Boolean(options?.merge) });
      },
      update: (ref2, data) => {
        writes.push({ kind: "update", path: ref2.path, data });
      },
      delete: (ref2) => {
        writes.push({ kind: "delete", path: ref2.path });
      }
    };
    const result = await callback(transaction);
    try {
      await commit(writes, reads);
      return result;
    } catch (error) {
      if (error.code !== "aborted" || attempt >= 4) throw error;
      await new Promise((resolve) => setTimeout(resolve, 30 * 2 ** attempt));
    }
  }
}
var collectionTables = {
  users: "user_profiles",
  orders: "orders",
  ledgerEntries: "ledger_entries",
  cashDepositRequests: "cash_deposit_requests",
  clientNotifications: "user_notifications",
  notificationReceipts: "notification_receipts"
};
function subscribe(tables, reload, error, filterFor, minimumIntervalMs = 80) {
  let active = true;
  let pending = false;
  let requestedAt;
  let lastStartedAt = 0;
  let timer;
  let failures = 0;
  let retryAt = 0;
  const schedule = () => {
    if (!active || pending || timer || requestedAt === void 0) return;
    const dueAt = Math.max(
      requestedAt + minimumIntervalMs,
      lastStartedAt + minimumIntervalMs,
      retryAt
    );
    timer = setTimeout(
      () => {
        timer = void 0;
        void refresh();
      },
      Math.max(0, dueAt - Date.now())
    );
  };
  const refresh = async () => {
    if (!active) return;
    if (pending) {
      requestedAt ?? (requestedAt = Date.now());
      return;
    }
    if (Date.now() < Math.max(retryAt, lastStartedAt + minimumIntervalMs)) {
      requestedAt ?? (requestedAt = Date.now());
      schedule();
      return;
    }
    requestedAt = void 0;
    pending = true;
    lastStartedAt = Date.now();
    try {
      await reload();
      failures = 0;
      retryAt = 0;
    } catch (reason) {
      const failure = reason;
      if (globalThis.__DEV__) {
        console.warn("Wasel subscription failed", {
          code: failure?.code,
          message: failure?.message
        });
      }
      if (active && (!failure.code || ["unavailable", "internal", "resource-exhausted"].includes(failure.code))) {
        const delay = Math.max(
          Math.min(3e4, 1e3 * 2 ** Math.min(failures++, 5)),
          Math.min(3e5, Math.max(0, Number(failure.details?.retryAfterSeconds) || 0) * 1e3)
        ) + Math.floor(Math.random() * 500);
        retryAt = Date.now() + delay;
        requestedAt ?? (requestedAt = Date.now());
      }
      if (active) error?.(reason);
    } finally {
      pending = false;
      schedule();
    }
  };
  const signal = () => {
    if (!active) return;
    requestedAt ?? (requestedAt = Date.now());
    schedule();
  };
  activeSubscriptions.add(signal);
  const channel = backendClient().channel(`wasel:${newId()}`);
  for (const table of tables)
    channel.on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table,
        ...filterFor?.(table) ? { filter: filterFor(table) } : {}
      },
      signal
    );
  void ready.then(async () => {
    const { data, error: sessionError } = await backendClient().auth.getSession();
    if (sessionError) throw sessionError;
    if (!active || !data.session) return;
    await backendClient().realtime.setAuth(data.session.access_token);
    if (!active) return;
    channel.subscribe((status) => {
      if (status === "SUBSCRIBED") signal();
    });
  }).catch((reason) => {
    if (active) error?.(reason);
  });
  void refresh();
  const poll = setInterval(signal, 12e4);
  return () => {
    active = false;
    activeSubscriptions.delete(signal);
    if (timer) clearTimeout(timer);
    clearInterval(poll);
    void backendClient().removeChannel(channel);
  };
}
function onSnapshot(ref2, callback, error) {
  const key = `${session?.user.id ?? "anonymous"}:${ref2 instanceof DocumentReference ? "document" : "query"}:${JSON.stringify(ref2)}`;
  const listener = { callback, error };
  let entry = sharedSnapshots.get(key);
  if (!entry) {
    entry = { listeners: /* @__PURE__ */ new Set(), stop: () => void 0 };
    sharedSnapshots.set(key, entry);
    const current = entry;
    current.stop = createSnapshotSubscription(
      ref2,
      (value) => {
        current.latest = value;
        current.failure = void 0;
        for (const subscriber of current.listeners) subscriber.callback(value);
      },
      (reason) => {
        current.failure = reason;
        for (const subscriber of current.listeners) subscriber.error?.(reason);
      }
    );
  }
  entry.listeners.add(listener);
  if (entry.latest !== void 0 && entry.failure === void 0) {
    const snapshot = entry.latest;
    queueMicrotask(() => {
      if (entry?.listeners.has(listener)) callback(snapshot);
    });
  }
  return () => {
    entry.listeners.delete(listener);
    if (!entry.listeners.size) {
      entry.stop();
      sharedSnapshots.delete(key);
    }
  };
}
var sharedSnapshots = /* @__PURE__ */ new Map();
function createSnapshotSubscription(ref2, callback, error) {
  const p = ref2.path.split("/");
  const name = ref2 instanceof DocumentReference ? p.at(-2) : p.at(-1);
  const table = collectionTables[name] ?? "catalog_entries";
  let active = true;
  let previous;
  let previousSignature;
  let failed = false;
  const cancel = subscribe(
    table === "user_profiles" ? [table, "wallet_accounts"] : [table],
    async () => {
      const result = ref2 instanceof DocumentReference ? await getDoc(ref2) : await getDocs(ref2);
      const signature = JSON.stringify(
        result instanceof QuerySnapshot ? result.docs.map((document2) => document2.record) : result.record
      );
      if (signature === previousSignature && !failed) return;
      failed = false;
      previousSignature = signature;
      if (result instanceof QuerySnapshot) {
        if (previous) previous.previous = void 0;
        result.previous = previous;
        previous = result;
      }
      if (active) callback(result);
    },
    (reason) => {
      failed = true;
      error?.(reason);
    },
    (tableName) => tableName === "catalog_entries" ? `collection=eq.${p[0]}` : p[0] === "users" && p[1] ? `${tableName === "user_profiles" ? "id" : "user_id"}=eq.${p[1]}` : void 0
  );
  return () => {
    active = false;
    cancel();
  };
}
async function getWalletHistory(options) {
  const result = await request("wallet-history", options);
  return { ...result, rows: result.rows.map((row) => hydrate(row)) };
}
function onWalletHistory(options, callback, error) {
  let active = true;
  const uid = auth.currentUser?.uid;
  const cancel = subscribe(
    ["orders", "cash_deposit_requests"],
    async () => {
      const result = await getWalletHistory(options);
      if (active && auth.currentUser?.uid === uid) callback(result);
    },
    error,
    () => `user_id=eq.${uid}`
  );
  return () => {
    active = false;
    cancel();
  };
}
async function resetAdminCommissions(input) {
  return request("admin-commission-reset", input);
}
async function getAdminReport(options) {
  return request("admin-reports", options);
}
function onAdminReport(options, callback, error) {
  const tables = {
    orders: ["orders", "chat_messages"],
    cashDeposits: ["cash_deposit_requests", "chat_messages"],
    balances: ["wallet_accounts", "user_profiles"],
    verification: ["user_profiles"],
    overview: ["orders", "cash_deposit_requests", "user_profiles", "wallet_accounts"],
    commissions: ["orders", "cash_deposit_requests", "catalog_entries"]
  };
  let active = true;
  const cancel = subscribe(
    tables[options.resource],
    async () => {
      const result = await getAdminReport(options);
      if (active) callback(result);
    },
    error,
    void 0,
    1e3
  );
  return () => {
    active = false;
    cancel();
  };
}
async function getUserDirectory(options) {
  const result = await request("documents", { action: "directory", ...options });
  return {
    users: result.docs.map((record) => ({
      ...hydrate(record.data),
      objectId: record.path.split("/").at(-1)
    })),
    total: result.total,
    summary: result.summary
  };
}
function watchUserDirectory(options, callback, error) {
  let active = true;
  const cancel = subscribe(
    ["user_profiles", "wallet_accounts"],
    async () => {
      const result = await getUserDirectory(options);
      if (active) callback(result);
    },
    error
  );
  return () => {
    active = false;
    cancel();
  };
}
var RealtimeReference = class {
  constructor(path) {
    this.path = path;
    __publicField(this, "kind", "realtime");
    __publicField(this, "ordering");
    __publicField(this, "maximum");
    __publicField(this, "last");
    __publicField(this, "hasEqual");
    __publicField(this, "equalValue");
  }
  get key() {
    return this.path.split("/").at(-1) ?? null;
  }
};
var StorageReference = class {
  constructor(fullPath) {
    this.fullPath = fullPath;
    __publicField(this, "kind", "storage");
  }
  get name() {
    return this.fullPath.split("/").at(-1);
  }
};
function ref(owner, path = "") {
  return owner.kind === "storage" ? new StorageReference(path) : new RealtimeReference(pathOf(owner, path ? [path] : []));
}
var orderByChild = (ordering) => ({ ordering });
var equalTo = (equalValue) => ({ hasEqual: true, equalValue });
var limitToLast = (maximum) => ({ maximum, last: true });
var limitToFirst = (maximum) => ({ maximum, last: false });
var DataSnapshot = class _DataSnapshot {
  constructor(key, value) {
    this.key = key;
    this.value = value;
  }
  val() {
    return this.value ?? null;
  }
  exists() {
    return this.value !== null && this.value !== void 0;
  }
  child(path) {
    return new _DataSnapshot(
      path.split("/").at(-1) ?? null,
      path.split("/").reduce((v, k) => v?.[k], this.value)
    );
  }
  forEach(callback) {
    for (const [key, value] of Object.entries(this.value ?? {}))
      if (callback(new _DataSnapshot(key, value)) === true) return true;
    return false;
  }
  get size() {
    return Object.keys(this.value ?? {}).length;
  }
};
async function get(ref2) {
  const data = await request("realtime", { action: "get", ...ref2 });
  return new DataSnapshot(ref2.key, data.value);
}
async function getChatMessagePage(ref2, options = {}) {
  return request("realtime", { action: "history", path: ref2.path, ...options });
}
var realtimeListeners = /* @__PURE__ */ new Map();
function onValue(ref2, callback, error) {
  let active = true;
  const tables = ref2.path.startsWith("userChatRooms") ? ["user_chat_rooms"] : ["chat_rooms", "chat_messages"];
  let previousSignature;
  const unsubscribe = subscribe(
    tables,
    async () => {
      const value = await get(ref2);
      const signature = JSON.stringify(value.val());
      if (active && signature !== previousSignature) {
        previousSignature = signature;
        callback(value);
      }
    },
    (reason) => {
      previousSignature = void 0;
      error?.(reason);
    },
    (table) => {
      const p = ref2.path.split("/");
      return table === "user_chat_rooms" ? `user_id=eq.${p[1]}` : p[1] ? `${table === "chat_rooms" ? "id" : "room_id"}=eq.${p[1]}` : void 0;
    }
  );
  const cancel = () => {
    active = false;
    unsubscribe();
    realtimeListeners.get(ref2)?.delete(cancel);
  };
  if (!realtimeListeners.has(ref2)) realtimeListeners.set(ref2, /* @__PURE__ */ new Set());
  realtimeListeners.get(ref2).add(cancel);
  return cancel;
}
function off(ref2) {
  for (const cancel of realtimeListeners.get(ref2) ?? []) cancel();
  realtimeListeners.delete(ref2);
}
function set(ref2, value) {
  return request("realtime", { action: "set", path: ref2.path, value });
}
function update(ref2, value) {
  return request("realtime", { action: "update", path: ref2.path, value });
}
function push(ref2, value) {
  const child = new RealtimeReference(`${ref2.path}/${Date.now().toString(36)}_${newId()}`);
  if (value !== void 0) {
    const promise = set(child, value).then(() => child);
    return Object.assign(promise, child);
  }
  return child;
}
async function getDownloadURL(ref2) {
  return (await request("files", { action: "url", path: ref2.fullPath })).url;
}
async function getMetadata(ref2) {
  return request("files", { action: "metadata", path: ref2.fullPath });
}
async function deleteObject(ref2) {
  return request("files", { action: "delete", path: ref2.fullPath });
}
async function uploadBytes(ref2, data, metadata, signal) {
  try {
    return await withRequestDeadline(
      async (uploadSignal) => {
        await ready;
        const identity = auth.currentUser?.uid;
        const { data: authData, error } = await backendClient().auth.getSession();
        if (error) throw authFailure(error);
        const token = authData.session?.access_token;
        const tokenIdentity = authData.session?.user.app_metadata?.firebase_uid ?? authData.session?.user.id;
        if (!identity || !token || auth.currentUser?.uid !== identity || tokenIdentity !== identity)
          throw requestError("unauthorized", "Please sign in.");
        if (uploadSignal.aborted) throw uploadSignal.reason;
        const response = await fetch(
          `${SUPABASE_URL}/functions/v1/wasel-api/upload?forceFunctionRegion=${SUPABASE_FUNCTION_REGION}`,
          {
            method: "POST",
            headers: {
              apikey: SUPABASE_PUBLISHABLE_KEY,
              "x-region": SUPABASE_FUNCTION_REGION,
              Authorization: `Bearer ${token}`,
              "Content-Type": metadata?.contentType ?? ("type" in data ? data.type : "application/octet-stream"),
              "x-wasel-path": encodeURIComponent(ref2.fullPath)
            },
            body: data,
            signal: uploadSignal
          }
        );
        const result = await readJsonResponse(response, uploadSignal);
        if (!response.ok || result?.error)
          throw Object.assign(new Error(result?.error?.message ?? "Upload failed."), {
            code: result?.error?.code ?? "unavailable"
          });
        if (!result?.data || result.data.fullPath !== ref2.fullPath || !(result.data.size > 0))
          throw requestError("unavailable", "The server did not confirm the uploaded file.");
        return { ref: ref2, metadata: result.data };
      },
      { timeoutMs: UPLOAD_TIMEOUT_MS, signal }
    );
  } catch (error) {
    if (!error.code?.startsWith("storage/")) error.code = `storage/${error.code ?? "unknown"}`;
    throw error;
  }
}
function uploadBytesResumable(ref2, data, metadata) {
  const controller = new AbortController();
  const size = "size" in data ? data.size : data.byteLength;
  const task = {
    snapshot: { ref: ref2, bytesTransferred: 0, totalBytes: size, state: "running" },
    cancel: () => {
      controller.abort();
      return true;
    }
  };
  let state, errorCallback, complete;
  const promise = uploadBytes(ref2, data, metadata, controller.signal).then((result) => {
    task.snapshot = { ...task.snapshot, ...result, bytesTransferred: size, state: "success" };
    state?.(task.snapshot);
    complete?.();
    return task.snapshot;
  }).catch((error) => {
    task.snapshot.state = "error";
    errorCallback?.(error);
    throw error;
  });
  void promise.catch(() => {
  });
  task.on = (_event, next, error, done) => {
    state = next;
    errorCallback = error;
    complete = done;
    state?.(task.snapshot);
    return () => {
      state = void 0;
      errorCallback = void 0;
      complete = void 0;
    };
  };
  task.then = promise.then.bind(promise);
  task.catch = promise.catch.bind(promise);
  return task;
}
function onAdminUnreadRooms(roomIds, callback, error) {
  return subscribe(
    ["chat_messages"],
    async () => {
      const batches = [];
      for (let start = 0; start < roomIds.length; start += 100) {
        batches.push(roomIds.slice(start, start + 100));
      }
      const results = await Promise.all(
        batches.map((batch) => request("realtime", { action: "unread", roomIds: batch }))
      );
      callback(Object.assign({}, ...results.map((result) => result.unread)));
    },
    error
  );
}
async function getChatRoomMetadata(ref2) {
  const result = await request("realtime", { action: "metadata", path: ref2.path });
  return new DataSnapshot(ref2.key, result.value);
}
export {
  CollectionReference,
  DataSnapshot,
  DocumentReference,
  DocumentSnapshot,
  EmailAuthProvider,
  QueryDocumentSnapshot,
  QuerySnapshot,
  RealtimeReference,
  SUPABASE_FUNCTION_REGION,
  SUPABASE_PUBLISHABLE_KEY,
  SUPABASE_URL,
  StorageReference,
  Timestamp,
  User,
  addDoc,
  auth,
  backendClient,
  collection,
  collectionGroup,
  createBrowserStorage,
  db,
  deleteDoc,
  deleteField,
  deleteObject,
  doc,
  equalTo,
  functions,
  get,
  getAdminReport,
  getChatMessagePage,
  getChatRoomMetadata,
  getDoc,
  getDocs,
  getDownloadURL,
  getMetadata,
  getUserDirectory,
  getWalletHistory,
  httpsCallable,
  increment,
  initializeBackend,
  limit,
  limitToFirst,
  limitToLast,
  memoryStorage,
  off,
  onAdminReport,
  onAdminUnreadRooms,
  onAuthStateChanged,
  onSnapshot,
  onValue,
  onWalletHistory,
  orderBy,
  orderByChild,
  push,
  query,
  reauthenticateWithCredential,
  ref,
  refreshBackendSubscriptions,
  request,
  resetAdminCommissions,
  rtdb,
  runTransaction,
  serverTimestamp,
  set,
  setDoc,
  signInWithEmailAndPassword,
  signOut,
  startAfter,
  storage,
  update,
  updateDoc,
  updateProfile,
  uploadBytes,
  uploadBytesResumable,
  watchUserDirectory,
  where,
  writeBatch
};
